// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_ribbed_bambu_vase_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_ribbed_bambu_vase_shade: ModuleSchema = {
  "id": "core_ribbed_bambu_vase_shade",
  "uniqueId": "B3D_RRSIK",
  "createdAt": "2026-10-02T14:00:22.897Z",
  "updatedAt": "2026-10-30T10:31:13.343Z",
  "label": "Ribbed Vase",
  "description": "core_ribbed_bambu_vase_shade parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_RIBBED_VASE"
  ],
  "sliders": [
    {
      "key": "shadeH",
      "label": "Vase Height",
      "min": 80,
      "max": 260,
      "step": 2,
      "default": 160,
      "unit": "mm"
    },
    {
      "key": "shadeBotDia",
      "label": "Base Diameter (Ø)",
      "min": 70,
      "max": 160,
      "step": 1,
      "default": 85,
      "unit": "mm"
    },
    {
      "key": "shadeBellyDia",
      "label": "Belly Bulge Diameter (Ø)",
      "min": 80,
      "max": 220,
      "step": 1,
      "default": 150,
      "unit": "mm"
    },
    {
      "key": "shadeTopDia",
      "label": "Top Mouth Diameter (Ø)",
      "min": 50,
      "max": 160,
      "step": 1,
      "default": 90,
      "unit": "mm"
    },
    {
      "key": "bellyPos",
      "label": "Belly Bulge Position",
      "min": 0.25,
      "max": 0.65,
      "step": 0.01,
      "default": 0.5
    },
    {
      "key": "ribCount",
      "label": "Rib / Flute Count",
      "min": 16,
      "max": 96,
      "step": 2,
      "default": 48
    },
    {
      "key": "ribDepth",
      "label": "Rib Flute Depth",
      "min": 0.5,
      "max": 6,
      "step": 0.25,
      "default": 2.5,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "ribbed_vase_shade",
      "label": "Ribbed Spherical Vase Body (45 Layers / 9mm Thread)",
      "default": "#f8fafc",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "ribbed_bambu_vase_shade_obj",
      "label": "Ribbed Pumpkin Vase Lampshade (Bambu LED Kit)",
      "name": "Ribbed Pumpkin Vase Lampshade (Bambu LED Kit)",
      "color": "#f8fafc",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "ribbed_vase_shade",
          "label": "Ribbed Spherical Vase Body (45 Layers / 9mm Thread)",
          "name": "Ribbed Spherical Vase Body (45 Layers / 9mm Thread)",
          "groupId": 0,
          "colorKey": "ribbed_vase_shade",
          "defaultColor": "#f8fafc",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
